import type { ReactNode } from "react"

/** What the tag means, for whoever wonders: the figure is arithmetic on the Act and the notice. */
const WORKED = "Worked out from the Act and the dates and amounts on the notice, the same way every time. Not written by AI."

/** A figure or line worked out by code (not by a model), with its working one click away. */
export function Code({ line, working, chip, tone }: { line: ReactNode; working: string; chip: string; tone?: string }) {
  return (
    <details className="nrd-row">
      <summary>
        <span className="nrd-row-l">{line} <span className="nrd-code" title={WORKED}><span className="show">see the working</span><span className="hide">hide the working</span></span></span>
        <span className={`nrd-chip ${tone ?? ""}`}>{chip}</span>
      </summary>
      <p className="nrd-working">{working}</p>
    </details>
  )
}
